import React from 'react'

const IconReporting = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 25.4001C6 25.4001 7.80001 23.6001 13.2 23.6001C18.6001 23.6001 22.2001 27.2001 27.6001 27.2001C33.0001 27.2001 34.8001 25.4001 34.8001 25.4001V3.80001C34.8001 3.80001 33.0001 5.60002 27.6001 5.60002C22.2001 5.60002 18.6001 2 13.2 2C7.80001 2 6 3.80001 6 3.80001V25.4001Z" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 38V25.3999" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconReporting